import React from 'react'
import Swiper, { SwiperSlide } from "../../../shared/swiper";
import Image from '../../../image'
import { GalleryWrap } from './gallery.stc';

const sliderSettings = {
	slidesPerView: 1,
	autoHeight: true,
	autoplay: {
		delay: 1000,
	}
}

const Gallery = ({ images, title }) => {
	return (
		<GalleryWrap>
			<Swiper options={sliderSettings}>
				{images && images.map((image, i) => (
					<SwiperSlide className="item" key={`gallery-${i}`}>
						<Image src={image} alt={title} />
					</SwiperSlide>
				))}
			</Swiper>
		</GalleryWrap>
	)
}


Gallery.defaultProps = {
	title: 'Gallery'
}

export default Gallery
